import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { CommonModule, DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from './app.component';
import { CustomSerializer } from '@mkp/shared/util-router';
import { AuthService } from '@auth0/auth0-angular';
import { APP_CONFIG, AppConfig } from '@mkp/shared/util-app-config';
import { HomeComponent } from '@mkp/core/feature-home';
import { NoNetworkComponent, ReadOnlyBannerComponent, VersionComponent } from '@mkp/core/ui';
import { SentryErrorHandler } from '@mkp/core/util-sentry';
import { GdprConsentComponent } from '@mkp/gdpr/feature-gdpr-consent';
import { GdprBannerComponent, GdprZendeskPlaceholderComponent } from '@mkp/gdpr/ui';
import { SnackbarModule } from '@mkp/shared/ui-library';
import { MediaApiResource } from '@mkp/shared/data-access';
import { CLICK_TRACKER } from '@mkp/shared/util-click-tracker';
import { MOOD_IMAGE_UPLOADER, MoodImageUploader } from '@mkp/shared/util-mood-image';
import { TealiumService } from '@mkp/tracking/feature-tealium';
import { Actions } from '@ngrx/effects';
import { RouterStateSerializer } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { appInitFactory } from './app-init.factory';
import { CoreModule } from './core/core.module';
import { ProgressInterceptor, RequestInterceptor, TimingInterceptor } from './core/interceptors';
import { ProgressBarService } from '@mkp/shared/util-progress-bar';
import { provideZendeskHost } from './providers/zendesk-host.provider';
import { RedirectService } from './services/redirect.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    CommonModule,
    VersionComponent,
    SnackbarModule,
    HomeComponent,
    NoNetworkComponent,
    ReadOnlyBannerComponent,
    GdprBannerComponent,
    GdprZendeskPlaceholderComponent,
    GdprConsentComponent,
  ],
  providers: [
    { provide: RouterStateSerializer, useClass: CustomSerializer },
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    { provide: Window, useValue: window },
    { provide: APP_CONFIG, useValue: AppConfig },
    { provide: LOCALE_ID, useValue: 'en-CH' },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'dd.MM.y' } },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitFactory,
      multi: true,
      deps: [Store, Actions, AuthService, Router, RedirectService],
    },
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    {
      provide: MOOD_IMAGE_UPLOADER,
      useFactory: (mediaApiResource: MediaApiResource): MoodImageUploader => ({
        upload: (picture) => mediaApiResource.fetchTokenAndUploadMedia(picture),
      }),
      deps: [MediaApiResource],
    },
    { provide: CLICK_TRACKER, useExisting: TealiumService },
    provideZendeskHost(),
    { provide: HTTP_INTERCEPTORS, useClass: TimingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProgressInterceptor,
      deps: [ProgressBarService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
